import type { SeasonalThemeDefinition } from '../../SeasonalTheme';

/** The app as it is, with no decorations at all. */
export const originalTheme: SeasonalThemeDefinition = {
  name: 'original',
  label: 'Original (no decorations)',
};

export default originalTheme;
